var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "400" },
          model: {
            value: _vm.dialogFirstConfirm,
            callback: function ($$v) {
              _vm.dialogFirstConfirm = $$v
            },
            expression: "dialogFirstConfirm",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-2" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h5" },
                [
                  _c("span", { staticClass: "ml-0" }, [
                    _vm._v("Eliminar oportunidad"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.onClose } },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(" fas fa-times "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("h3", { staticClass: "font-weight-thin" }, [
                          _vm._v(
                            "\n              ¿Está seguro que\n              "
                          ),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(" desea eliminar la oportunidad"),
                          ]),
                          _vm._v("?\n            "),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "mr-2" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { rounded: "", text: "" },
                      on: { click: _vm.onClose },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", rounded: "", dark: "" },
                      on: { click: _vm.onStepSecondConfirm },
                    },
                    [_vm._v(" Eliminar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "400" },
          model: {
            value: _vm.dialogSecondConfirm,
            callback: function ($$v) {
              _vm.dialogSecondConfirm = $$v
            },
            expression: "dialogSecondConfirm",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-2" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h5" },
                [
                  _c("span", { staticClass: "ml-0" }, [
                    _vm._v("Eliminar oportunidad"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.onClose } },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(" fas fa-times "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("h3", { staticClass: "font-weight-thin" }, [
                          _vm._v(
                            "\n              No se puede recuperar una oportunidad una vez eliminada, ¿está seguro que\n              "
                          ),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(" desea eliminar la oportunidad"),
                          ]),
                          _vm._v("?\n            "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.responseErrorMessage
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: { dense: "", text: "", type: "error" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.responseErrorMessage) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "mr-2" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { rounded: "", text: "" },
                      on: { click: _vm.onClose },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loading,
                        color: "red",
                        rounded: "",
                        dark: "",
                      },
                      on: { click: _vm.onDelete },
                    },
                    [_vm._v(" Eliminar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }